import { Dispatch, SetStateAction, useEffect } from 'react';

import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { Box, Button } from '@mui/material';

import AddApp from '@/assets/icons/AddApp';
import { PageInformationContext } from '@/context/PageInformationContext';
import { useEditDashboardDraft } from '@/features/Dashboard/context/EditDashboardDraft';
import { ButtonsContainer } from '@/features/Dashboard/drawer/components/ButtonsContainer';
import { DrawerStep, useDrawerSteps } from '@/features/Dashboard/drawer/context/DrawerStepsContext';
import { useAppForm } from '@/features/Dashboard/form/AppForm/context';
import { MarketApps } from '@/features/Dashboard/types';
import { useMarketPreview } from '@/hooks/api/market';
import MarketsComponents from '@/pages/Markets/MarketsComponents';
import MarketsSkeleton from '@/pages/Markets/MarketsSkeleton';

import { DashboardLayout } from '../../components/DashboardLayout';
import { DashboardStep } from '../../constants/DashboardStep';

export const ViewDashboard = ({
  setStep,
  dashboardConfig
}: {
  setStep: Dispatch<SetStateAction<DashboardStep>>;
  dashboardConfig: MarketApps | undefined;
}) => {
  const { data, isLoading } = useMarketPreview(dashboardConfig);
  const { setDrawerStep } = useDrawerSteps();
  const { dashboardName } = useEditDashboardDraft();

  const { setMode } = useAppForm();

  useEffect(() => {
    setMode('create');
  }, []);

  if (isLoading) {
    return <MarketsSkeleton />;
  }

  return (
    <DashboardLayout
      renderRight={
        <ButtonsContainer>
          <Button
            color='secondary'
            size='large'
            sx={{
              height: '48px',
              width: '192px'
            }}
            variant='contained'
            onClick={() => {
              setStep(DashboardStep.Edit);
            }}
          >
            <EditOutlinedIcon sx={{ fontSize: '24px !important' }} />
            Edit
          </Button>
          <Button
            color='secondary'
            size='large'
            sx={{
              height: '48px',
              width: '192px'
            }}
            variant='contained'
            onClick={() => {
              setDrawerStep(DrawerStep.SelectApp);
            }}
          >
            <AddApp
              fill='#F8F8F8'
              sx={{
                width: '24px',
                height: '24px'
              }}
            />
            <Box
              sx={{
                marginLeft: '8px'
              }}
            >
              Add an app
            </Box>
          </Button>
        </ButtonsContainer>
      }
      title={dashboardName}
    >
      <PageInformationContext value={{ mainPageTitle: 'Dashboard' }}>
        {data && (
          <MarketsComponents
            components={data.components}
            showAddToDashboard={false}
            showShareBlock={false}
          />
        )}
      </PageInformationContext>
    </DashboardLayout>
  );
};
